import moment from 'moment'
export default {
  orders: [
    {
      id: 1,
      idDay: 1,
      date: moment(),
      dateFinish: moment().subtract(30, 'minutes'),
      status: 1,
      typeDelivery: 1,
      typePayment: 2,
      time: null,
      branch: 0,
      discountType: null,
      discountValue: null,
      courier: null,
      comment: 'Hello world',
      client: {
        id: 22,
        name: 'Анатолий',
        phone: '89043769437'
      },
      products: [
        {
          id: 5,
          name: 'Бургер',
          cost: 150,
          count: 2
        },
        {
          id: 6,
          name: 'Пицца Пепперони',
          cost: 200,
          count: 25
        }
      ],
      orderCost: 5300,
      address: {
        street: 'Моторостроителей',
        house: 2,
        entrance: 3,
        floor: 2,
        apartament: 200,
        office: 12
      },
      partner: null
    },
    {
      id: 2,
      idDay: 2,
      date: new Date(),
      status: 0,
      typeDelivery: 1,
      typePayment: 0,
      time: null,
      branch: 0,
      discountType: null,
      discountValue: null,
      comment: 'Положить 1000 палочек',
      client: {
        id: 22,
        name: 'Петя',
        phone: '89228953867'
      },
      products: [
        {
          id: 5,
          name: 'Бургер',
          cost: 150,
          count: 2
        },
        {
          id: 6,
          name: 'Пицца Пепперони',
          cost: 200,
          count: 25
        }
      ],
      orderCost: 5300,
      address: {
        street: '50 лет ВЛКСМ',
        house: 5,
        entrance: 'Последний',
        floor: 2,
        apartament: 200,
        office: 12
      },
      partner: null
    },
    {
      id: 3,
      idDay: 3,
      date: new Date(),
      status: 1,
      typeDelivery: 2,
      typePayment: 2,
      time: null,
      branch: 1,
      discountType: null,
      discountValue: null,
      comment: '5 дверь Слева',
      courier: {
        id: 2,
        name: 'Анатолий',
        phone: '85679346547'
      },
      client: {
        id: 22,
        name: 'Василий',
        phone: '89048753137'
      },
      products: [
        {
          id: 5,
          name: 'Бургер BBQ',
          cost: 150,
          count: 2
        }
      ],
      orderCost: 300,
      address: {},
      partner: 1
    },
    {
      id: 4,
      idDay: 4,
      date: moment(),
      dateFinish: moment().subtract(30, 'minutes'),
      status: 1,
      typeDelivery: 1,
      typePayment: 2,
      time: null,
      branch: 0,
      discountType: null,
      discountValue: null,
      courier: null,
      comment: 'Hello world',
      client: {
        id: 22,
        name: 'Анатолий',
        phone: '89043769437'
      },
      products: [
        {
          id: 5,
          name: 'Бургер',
          cost: 150,
          count: 2
        },
        {
          id: 6,
          name: 'Пицца Пепперони',
          cost: 200,
          count: 25
        }
      ],
      orderCost: 5300,
      address: {
        street: 'Моторостроителей',
        house: 2,
        entrance: 3,
        floor: 2,
        apartament: 200,
        office: 12
      },
      partner: null
    },
    {
      id: 5,
      idDay: 5,
      date: moment(),
      dateFinish: moment().subtract(30, 'minutes'),
      status: 1,
      typeDelivery: 1,
      typePayment: 2,
      time: null,
      branch: 0,
      discountType: null,
      discountValue: null,
      courier: null,
      comment: 'Hello world',
      client: {
        id: 22,
        name: 'Анатолий',
        phone: '89043769437'
      },
      products: [
        {
          id: 5,
          name: 'Бургер',
          cost: 150,
          count: 2
        },
        {
          id: 6,
          name: 'Пицца Пепперони',
          cost: 200,
          count: 25
        }
      ],
      orderCost: 5300,
      address: {
        street: 'Моторостроителей',
        house: '4а',
        entrance: 3,
        floor: 2,
        apartament: 200,
        office: 12
      },
      partner: 2
    }
  ],
  statusOptions: {
    0: 'Новый',
    1: 'В работе',
    2: 'На кухне',
    3: 'Доставка'
  },
  paymentOptions: {
    0: 'Наличные',
    1: 'Картой на месте',
    2: 'Картой онлайн'
  },
  branchOptions: {
    0: '50 лет ВЛКСМ',
    1: 'Широтная'
  },
  pointsOptions: {
    0: 'brunch',
    1: 'giveTwo',
    2: 'takeshi'
  },
  discountOptions: {
    0: 'Процент от стоимости',
    1: 'Скидка на сумму'
  },
  opsVueScroll: {
    vuescroll: {
      sizeStrategy: 'number'
    },
    scrollPanel: {
      scrollingX: false
    },
    rail: {
      size: '10px',
      opacity: 0.1
    },
    bar: {
      keepShow: true
    }
  },
  opsPerfectScroll: {
    suppressScrollX: true
  },
  partnerOptions: {
    0: 'Зака-зака',
    1: 'Деливери клаб',
    2: 'Деливери клаб'

  }
}



// WEBPACK FOOTER //
// ./src/tempVariables/commonVars.js